<div *ngIf="showSearchInput" class="relative mb-3">
  <div class="flex items-center bg-white rounded-lg border-2 border-blue-300 shadow-sm">
    <mat-icon class="text-blue-600 ml-3">search</mat-icon>
    <input 
      class="flex-1 px-3 py-3 text-sm border-none outline-none rounded-lg"
      type="text"
      #addresstext
      placeholder="Buscar dirección..."
      (input)="onSearchInput($event)"
    />
    <mat-icon *ngIf="addresstext?.value && !isSearching" class="text-gray-400 mr-3 cursor-pointer hover:text-gray-600" (click)="clearSearch()">close</mat-icon>
    <mat-icon *ngIf="isSearching" class="text-blue-600 mr-3 animate-spin text-sm">refresh</mat-icon>
  </div>
</div>

<div class="map-container" [style.height]="showSearchInput ? null : height" [style.width]="width">
  <div #mapContainer class="leaflet-map"></div>
</div>
